<template>
  <div class="wrap">
    <div class="list">
      <div class="emptyBox colAc" v-if="list.length == 0">
        <img src="../assets/static/emptyList.png" alt="" />
        <div>暂时还没有授权记录哦</div>
      </div>
      <div class="listitem" v-for="(item, index) in list" :key="index">
        <div class="organization_campus">{{ item.institutionName }}</div>
        <div class="itemLine">
          机构状态
          <span>{{ item.isAuthorize == 1 ? "已授权" : "未授权" }}</span>
        </div>
        <!-- <div class="itemLine">
          加入时间
          <span>{{ item.joinTime }}</span>
        </div>
        <div class="itemLine">
          授权时间
          <span>{{ item.authTime }}</span>
        </div> -->
        <div class="btn rowJeAc">
          <div v-if="item.isAuthorize == 1">
            <div
              class="cacelPower"
              @click="cancelImpower(index)"
            >
              取消授权
            </div>
          </div>
          <div v-else>
            <div class="power" @click="goImpower(index)">
              授权
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mask rowJcAc" v-if="impowerMasking">
      <div class="popover">
        <div class="title center">
          确认授权吗?<br /><span class="spec"
            >授权后该微信将可以接收查询<br />这个机构的信息</span
          >
        </div>
        <div class="popover_bottom rowJbAc">
          <div class="cancelbtn center" @click="cancelOperation()">取消</div>
          <div class="confirmbtn center" @click="confirmAuthorized()">确定</div>
        </div>
      </div>
    </div>

    <div class="mask rowJcAc" v-if="cancelMasking">
      <div class="popover">
        <div class="title center">
          确认取消吗?<br /><span class="spec"
            >取消后将不在接收这个机构<br />发送的任何通知</span
          >
        </div>
        <div class="popover_bottom rowJbAc">
          <div class="cancelbtn center" @click="cancelOperation()">取消</div>
          <div class="confirmbtn center" @click="cancelAuthorized()">确定</div>
        </div>
      </div>
    </div>
    <div class="alsrtInfo" :style="{ display: displayStsates }">
      <div class="profPrompt_test center">
        <span>{{ aletMsg }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAuthorizeListAPI,
  postAuthorizationAPI,
  deleteAuthorizationAPI,
} from "../utils/api/api";
export default {
  data() {
    return {
      impowerMasking: false,
      cancelMasking: false,
      clickIdx: -1,
      id: "",
      status: "",
      list: [],

      aletMsg: "",
      displayStsates: "none",
    };
  },
  created() {
    this.getAuthorizeList();
  },
  mounted() {
    //   此处需要调取数据接口，获得各校区数据
  },
  methods: {
    //   取消授权
    cancelImpower(index) {
      if(this.list.filter(item => {return item.isAuthorize == 1}).length < 2) {
        this.alertDia('客户已授权信息至少保留一条！')
        return
      }
      this.clickIdx = index
      this.cancelMasking = true;
    },
    // 授权
    goImpower(index) {
      this.clickIdx = index
      this.impowerMasking = true;
    },
    // 取消
    cancelOperation() {
      this.cancelMasking = false;
      this.impowerMasking = false;
    },
    //获取授权列表
    getAuthorizeList() {
      getAuthorizeListAPI({
        productId: 1,
        clientId: '1004',
        thirdUniqueId: this.$common.getCache('openid')
      }).then((res) => {
        console.log("授权列表", res);
        if (res.resultCode == 200) {
          this.list = []
          this.list = res.data?res.data:[];
        } else {
          console.log("获取授权列表失败");
        }
      });
    },
    // 取消授权
    cancelAuthorized() {
      var obj = {
        institutionCode: this.list[this.clickIdx].institutionCode,
        userId: this.list[this.clickIdx].userId,
      };
      console.log("提交授权obj", obj);
      deleteAuthorizationAPI(obj).then((res) => {
        if (res.resultCode == 200) {

          this.getAuthorizeList();
          this.cancelMasking = false;
          this.impowerMasking = false;
        } else {
          this.alertDia(res.resultStr);
        }
      });
    },
    // 确认是否授权
    confirmAuthorized() {
      var obj = {
        institutionCode: this.list[this.clickIdx].institutionCode,
        userId: this.list[this.clickIdx].userId,
      };
      console.log("提交授权obj", obj);
      postAuthorizationAPI(obj).then((res) => {
        if (res.resultCode == 200) {

          this.getAuthorizeList();
          this.cancelMasking = false;
          this.impowerMasking = false;
        } else {
          this.alertDia(res.resultStr);
        }
      });
    },
    // 提示弹框
    alertDia(msg) {
      this.displayStsates = "block";
      this.aletMsg = msg;
      // 延迟2秒后消失 自己可以更改时间
      window.setTimeout(() => {
        this.displayStsates = "none";
      }, 2000);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  background: #f4faff;
  padding: 0px 0.15rem;
  box-sizing: border-box;
  overflow: auto;
}
.list {
  flex: 1;
  overflow: auto;
}
.listitem {
  margin-top: 28px;
  background: linear-gradient(180deg, #d8f1ff 0%, #ffffff 100%);
  box-shadow: 4px 4px 11px 0px rgba(229, 236, 243, 0.8),
    -9px -9px 22px 0px rgba(255, 255, 255, 0.5);
  border-radius: 17px;
  padding: 16px 20px;
  // height: 170px;
  box-sizing: border-box;
}
.itemLine {
  color: #333843;
  font-size: 14px;
  margin-top: 8px;
}
.listitem span {
  margin-left: 16px;
}
.organization_campus {
  font-size: 17px;
  font-weight: 500;
  color: #333843;
  line-height: 24px;
  margin-bottom: 12px;
}
.btn {
  //   margin-left: 75%;
}
.power {
  font-size: 15px;
  color: #6985ff;
  margin-right: 15px;
}
.cacelPower {
  font-size: 15px;
  color: #6985ff;
  background: transparent;
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.popover {
  width: 270px;
  //   height: 145px;
  background: #ffffff;
  border-radius: 14px;
  padding-top: 19px;
  box-sizing: border-box;
}
.title {
  font-size: 17px;
  font-weight: 500;
  color: #333843;
  line-height: 22px;
}
.spec {
  font-size: 13px;
  font-weight: 400;
  color: #333843;
  line-height: 16px;
}
.popover_bottom {
  margin-top: 21px;
  border-top: 1px solid #dddfe6;
  box-sizing: border-box;
}
.cancelbtn {
  border-right: 1px solid #dddfe6;
  font-size: 17px;
  font-weight: 500;
  color: #333843;
  width: 135px;
  height: 48px;
  line-height: 48px;
}
.confirmbtn {
  font-size: 17px;
  font-weight: 500;
  color: #6985ff;
  width: 135px;
  height: 48px;
  line-height: 48px;
}
.alsrtInfo {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 80%;
  left: 4%;
  z-index: 1000;
}
.profPrompt_test {
  display: inline-block;
  box-sizing: border-box;
  width: 345px;
  height: 44px;
  background: #222222;
  border-radius: 11px;
  line-height: 44px;
  padding: 0px 25px;
  font-size: 12px;
  margin: auto;
  color: #ffffff;
}
.emptyBox {
  img {
    width: 165px;
    height: 114px;
    margin-top: 40px;
  }
  > div {
    font-size: 13px;
    color: #9ea8ba;
    line-height: 19px;
  }
}
</style>
